import script from "./FeedbackLetterDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackLetterDialog.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackLetterDialog.vue?vue&type=style&index=0&id=b6ee6040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6ee6040"]])

export default __exports__